import { CustomerOrderOfferLineView } from "src/api/generated/erp/db/types/tables/customerOrderOfferLineView.ts";
import { CustomerOrderOfferLinesDataGridApi } from "src/api/generated/erp/sales/customerOrderOffer/api/customerOrderOfferLinesDataGridApi.ts";

export type SubConfigurationImportSourceOfferLine = Pick<
	CustomerOrderOfferLineView,
	| "customerOrderOfferLineId"
	| "lineNumber"
	| "salesPartNo"
	| "salesPartType"
	| "configurationOrPartDescription"
	| "partConfigurationId"
>;

export async function fetchSourceOfferLinesRecursively(
	fetchLines: (parentLineId: number | null) => Promise<SubConfigurationImportSourceOfferLine[]>,
	parentLineId: number | null = null,
): Promise<SubConfigurationImportSourceOfferLine[]> {
	const lines = await fetchLines(parentLineId);
	const descendantsByLine = await Promise.all(
		lines.map((line) =>
			line.salesPartType === "PACKAGE_" ?
				fetchSourceOfferLinesRecursively(fetchLines, line.customerOrderOfferLineId)
			:	[],
		),
	);

	return lines.flatMap((line, index) => [line, ...descendantsByLine[index]!]);
}

/** The lines of the offer, also inside packages, that have a configuration, without the line being configured. */
export async function fetchCustomerOfferLinesWithConfiguration(
	customerOfferId: number,
	currentCustomerOfferLineId: number | undefined,
): Promise<SubConfigurationImportSourceOfferLine[]> {
	const allLines = await fetchSourceOfferLinesRecursively(async (parentLineId) => {
		const data = await CustomerOrderOfferLinesDataGridApi.getData({
			customerOrderOfferId: customerOfferId,
			parentLineId: parentLineId,
			searchQuery: "",
		});
		return data.customerOrderOfferLines;
	});
	return allLines.filter(
		(line) => line.customerOrderOfferLineId !== currentCustomerOfferLineId && line.partConfigurationId != null,
	);
}
